module.exports = __webpack_public_path__ + "img/AntDesign.04fb93f7.png";